import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@/modules/auth/hooks/useAuth';

export const Route = createFileRoute('/auth/logout')({
  component: LogoutPage,
});

function LogoutPage() {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    void logout().finally(() => {
      void navigate({ to: '/auth/login', replace: true });
    });
  }, [logout, navigate]);

  return (
    <div className="flex flex-col items-center gap-3 py-8">
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      <p className="text-sm text-muted-foreground">{t('auth.logout.title')}</p>
    </div>
  );
}
